import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { OPTION_LIST_ITEM } from '../constants';
import { useOnToggleAll } from '../../Dropdown/utils';
import { useOnSearchQueryChange } from './useOnSearchQueryChange';
export var useOptionList = function useOptionList(_ref) {
  var disabled = _ref.disabled,
      options = _ref.options,
      multiple = _ref.multiple,
      internalValue = _ref.internalValue,
      blurInput = _ref.blurInput,
      setIsOptionListShown = _ref.setIsOptionListShown,
      onValueUpdate = _ref.onValueUpdate,
      onChange = _ref.onChange,
      setInternalValue = _ref.setInternalValue,
      internalOptions = _ref.internalOptions,
      _ref$dynamicInternalO = _ref.dynamicInternalOptions,
      dynamicInternalOptions = _ref$dynamicInternalO === void 0 ? internalOptions : _ref$dynamicInternalO,
      setInternalOptions = _ref.setInternalOptions,
      enableSelectAllOption = _ref.enableSelectAllOption,
      _ref$selectAllLabel = _ref.selectAllLabel,
      selectAllLabel = _ref$selectAllLabel === void 0 ? 'Select all' : _ref$selectAllLabel,
      enableSearchOption = _ref.enableSearchOption,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? 'Search' : _ref$searchPlaceholde,
      _ref$defaultSearchQue = _ref.defaultSearchQuery,
      defaultSearchQuery = _ref$defaultSearchQue === void 0 ? '' : _ref$defaultSearchQue,
      isFlat = _ref.isFlat,
      restProps = _objectWithoutProperties(_ref, ["disabled", "options", "multiple", "internalValue", "blurInput", "setIsOptionListShown", "onValueUpdate", "onChange", "setInternalValue", "internalOptions", "dynamicInternalOptions", "setInternalOptions", "enableSelectAllOption", "selectAllLabel", "enableSearchOption", "searchPlaceholder", "defaultSearchQuery", "isFlat"]);

  var _useState = useState(defaultSearchQuery),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var onSearchChange = useOnSearchQueryChange(internalValue, internalOptions, setInternalValue, setInternalOptions, searchQuery, enableSearchOption);

  var resetListState = function resetListState() {
    setSearchQuery('');
    onSearchChange();
  };

  var onOptionSelect = useCallback(function (item) {
    if (internalOptions) {
      onValueUpdate(internalValue, multiple, item, item.value, options, isFlat);
    }

    if (!multiple) {
      setIsOptionListShown(false);
      resetListState();
    }

    if (blurInput) {
      blurInput();
    }
  }, [internalOptions, onValueUpdate, internalValue, multiple, options, isFlat, blurInput, setSearchQuery]);
  var onToggleAll = useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange);
  useEffect(function () {
    return onSearchChange();
  }, [searchQuery]);

  var handleToggleAll = function handleToggleAll() {
    return onToggleAll();
  };

  var handleSearchChange = useCallback(function (event) {
    var newSearchQuery = event.target.value || '';
    setSearchQuery(newSearchQuery);
  }, [setSearchQuery, setSearchQuery]);
  var selectAllCheckedIcon = internalOptions.length === internalValue.length ? 'tick' : 'dash';
  return {
    rootProps: restProps,
    dropdownOptionItemProps: function dropdownOptionItemProps(item) {
      return {
        'data-testid': OPTION_LIST_ITEM,
        isSelected: internalValue.includes(item.value),
        item: item,
        key: item.value,
        onOptionSelect: onOptionSelect,
        multiple: multiple
      };
    },
    selectAllItemProps: {
      item: useMemo(function () {
        return {
          value: -1,
          label: selectAllLabel
        };
      }, [selectAllLabel]),
      checkedIcon: selectAllCheckedIcon,
      isSelected: internalValue.length > 0,
      onOptionSelect: handleToggleAll,
      multiple: multiple
    },
    dropdownOptionListSearchProps: {
      placeholder: searchPlaceholder,
      onChange: handleSearchChange,
      defaultQuery: searchQuery
    },
    internalOptions: internalOptions,
    dynamicInternalOptions: dynamicInternalOptions,
    disabled: disabled,
    internalValue: internalValue,
    multiple: multiple,
    enableSelectAllOption: enableSelectAllOption,
    enableSearchOption: enableSearchOption,
    searchQuery: searchQuery,
    isOptionListHeaderRendered: enableSelectAllOption || enableSearchOption,
    isSelectAllOptionRendered: enableSelectAllOption && multiple && !searchQuery
  };
};